<template>
    <div id="app">
        <div class="header">
            <div class="logout-bg" @click="logout">
                ログアウト
            </div>
            <div class="header-title">Photo Uploader</div>

        </div>
        <div style="height: 62vh;">
            <div v-if="canUse">
                <video v-show="showVideo" id="video" style="width: 100%;height: 62vh; display: block;" autoplay loop muted
                       playsinline webkit-playsinline="true"></video>
                <canvas  style="height: 62vh; " v-show="showCanvas" id="canvas"></canvas>
                <div id="imageData"></div>
            </div>
            <div v-else>
                <el-image v-if="imageUrl" :src="imageUrl" style="height: 62vh;"  fit="fit" :preview-src-list="imageList"/>
                <div v-else style="font-size: 3.6vw;line-height: 62vh;height: 62vh;">写真を選択してください</div>
            </div>
        </div>
        <div style="display: flex;">
            <div v-if="canUse" style="margin: 0 auto">
                <button class="btn-bg" @click="clickButton()">{{ buttonText }}</button>
                <button class="btn-bg" @click="upload">アップロード</button>
            </div>

            <el-upload v-else
                       style="margin: 0 auto;"
                       class="avatar-uploader "
                       action="#"
                       :before-upload="handleUpload"
                       :show-file-list="false">
                <i class="el-icon-plus avatar-uploader-icon btn-bg2"> {{ buttonText }}</i>
            </el-upload>

        </div>
        <custom-dialog v-show="showMessage" :show-message="showMessage" :sub-message='subMessage'
                       @dialogClick="dialogClick" :type="dialogType"/>
    </div>
</template>

<script>
// import {uploadImage} from "@/utils/api";
import axios from "axios";
import {TOKEN} from "@/utils/mutation-types";
import {baseURL} from "@/utils/request";
import CustomDialog from "@/components/CustomDialog.vue";

const FormData = require('form-data');

export default {
    components: {CustomDialog},
    data() {
        return {
            canUse: true,
            showVideo: true,
            showCanvas: false,
            myVideo: null,
            constraints: {},
            videoStream: null,
            buttonText: "写真撮影",
            trackerTask: null,
            imageUrl: '', // 存放已选中的图片链接
            imageList:[],
            orderId: '',
            countdownTime: 600,
            countdownTimeStr: '',
            state: 0,
            dialogType: 0,
            showMessage: false,
            subMessage: "",
            taskId: null
        }
    },
    create() {
    },
    mounted() {
        let that = this;
        that.createVideo();
        that.taskId = setInterval(function () {
            that.countdown();

        }, 1000);
        if (that.$route.params.orderId) {
            console.log('orderId', that.$route.params.orderId);
            that.$set(that, "orderId", that.$route.params.orderId);
        }

    },
    methods: {
        logout() {
            this.state = -1;
            this.showMessageDialog("入力途中のデータは\n保存されません", 2)

        },
        back() {
            this.state = -2;
            this.showMessageDialog("入力途中のデータは\n保存されません", 2)
        },
        showMessageDialog(subMessage, dialogType) {
            this.$set(this, 'showMessage', true)
            this.$set(this, 'dialogType', dialogType)
            this.$set(this, 'subMessage', subMessage)
        },
        dialogClick(val) {
            this.$set(this, 'showMessage', false)
            this.$set(this, 'subMessage', '')
            if (val) {
                console.log('this.state:' + this.state);
                if (this.state === -1) {
                    window.document.location = "/ss/index.php";
                } else if (this.state === -2) {
                    this.$router.back();
                }
            }
            this.$set(this, 'state', 0)
        },
        countdown() {
            let that = this;
            let diff = that.countdownTime;
            diff--;
            if (diff <= 0) {
                this.$router.push('/logoutIndex')
                clearInterval(that.taskId)
                return
            }

            let minutes = Math.floor((diff / 60));
            let seconds = Math.floor((diff % 60));
            that.$set(that, 'countdownTimeStr', `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`)
            that.$set(that, 'countdownTime', diff)
        },
        handleTouchStart() {
            console.log('handleTouchStart')
            if (this.countdownTime !== 600) {
                this.$set(this, 'countdownTime', 600)
            }
        },
        // handleSuccess(response) {
        //     this.imageUrl = response.data; // 获取服务器返回的图片链接并赋值给 imageUrl
        // },
        handleUpload(file) {
            var that = this;
            // this.imageUrl = file;
            // let shopId = localStorage.getItem(SHOP_ID)
            // uploadImage(file.raw,this.orderId,this.orderId+"_car.jpg")
            var data = new FormData();
            data.append('file', file);
            data.append('orderId', that.orderId);
            data.append('fileName', new Date().getTime() + "_car.jpg");


            var config = {
                method: 'post',
                url:  baseURL+'/App/Upload_Upload/uploadCarPhoto',
                headers: {
                    'Authorization': localStorage.getItem(TOKEN)
                },
                data: data
            };
            that.$showLoading()
            axios(config)
                .then(function (response) {
                    console.log(JSON.stringify(response.data));
                    that.$alert('アップロード成功しました');

                    // that.$set(that, 'imageUrl', response.data.data.url);
                    // console.log("imageUrl", that.imageUrl)
                    that.$set(that, 'buttonText', "もう一回アップロード");
                    that.$hideLoading();
                })
                .catch(function (error) {
                    console.log(error);
                    that.$alert('アップロード失敗しました');
                    that.$hideLoading();
                });

            const myBlob = new window.Blob([file], { type: 'image/jpeg' })
            const qrUrl = window.URL.createObjectURL(myBlob)
            that.$set(that, 'imageUrl', qrUrl);
            that.$set(that, 'imageList', [qrUrl]);
        },
        createVideo() {
            // 获取video标签
            this.myVideo = document.querySelector('#video');

            // JavaScript 调用设备前后摄像头参数配置
            this.constraints = { // 初始值
                audio: false, // 获取音频轨
                video: {  // 获取并设定视频轨相应参数
                    width: {
                        min: 1280, // 最低视频分辨率宽值标准
                        ideal: 1920, // 最优视频分辨率宽值标准，权重最高，优先使用接近该值数据
                        max: 2560 // 最高视频分辨率宽值标准
                    },
                    height: {
                        min: 720,
                        ideal: 1080,
                        max: 1440
                    },
                    facingMode: 'environment'  // user -- 前置 、environment -- 后置、{ exact: "environment" } -- 前置调用后置摄像头
                } // 流以正确的宽度和高度比例进入，如果它是处于纵向模式的手机，则需要进行尺寸反转
            };

            if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) { // 检查浏览器是否支持此API
                this.switchDirection(); // 浏览器支持
            } else {
                console.log('浏览器暂不支持');
                this.$set(this, 'canUse', false)
            }
        },
        clickButton() {
            if (this.showCanvas) {
                this.buttonText = "写真撮影";
                this.myVideo.play();
                this.showVideo = true;
                this.showCanvas = false;
            } else {
                this.buttonText = "戻る"
                this.myVideo.pause();
                this.screenshot();
            }
        },
        screenshot() {
            // 绘制预览图片
            var canvas = document.querySelector('#canvas');
            canvas.width = this.myVideo.videoWidth;
            canvas.height = this.myVideo.videoHeight;
            // const vm = document.body.clientWidth;
            canvas.getContext('2d').drawImage(this.myVideo, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/png');
            this.$set(this, 'imageUrl', dataURL);
            this.$set(this, 'imageList', [dataURL]);
            this.showVideo = false;
            this.showCanvas = true;
        },
        // 你想在已经播放视频的情况下更换摄像机的前后摄像头，需要先停止当前的前置或者后置的视频流，再将其替换成摄像机的前置或者后置的视频流。
        async switchDirection() {
            if (this.videoStream) {
                this.videoStream.getTracks().forEach((track) => {
                    track.stop();
                });
            }
            try {
                // 详细请参考：https://developer.mozilla.org/zh-CN/docs/Web/API/MediaDevices/getUserMedia
                this.videoStream = await navigator.mediaDevices.getUserMedia(this.constraints); // 调用将询问用户是否允许访问摄像机。如果用户拒绝，它将引发异常并且不返回流。因此，必须在 try/catch 块内处理这种情况,它返回一个Promise，必须使用 async/await 或 then 块
                /*
                异常：
                1、AbortError：中止错误
                    尽管用户和操作系统都授予了访问设备硬件的权利，而且未出现可能抛出NotReadableError异常的硬件问题，但仍然有一些问题的出现导致了设备无法被使用。
                2、NotAllowedError：拒绝错误
                    用户拒绝了当前的浏览器实例的访问请求；或者用户拒绝了当前会话的访问；或者用户在全局范围内拒绝了所有媒体访问请求。
                3、NotFoundError：找不到错误
                    找不到满足请求参数的媒体类型。
                4、NotReadableError：无法读取错误
                    尽管用户已经授权使用相应的设备，操作系统上某个硬件、浏览器或者网页层面发生的错误导致设备无法被访问。
                5、OverconstrainedError：无法满足要求错误
                    指定的要求无法被设备满足，此异常是一个类型为OverconstrainedError的对象，拥有一个constraint属性，这个属性包含了当前无法被满足的constraint对象，还拥有一个message属性，包含了阅读友好的字符串用来说明情况。
                6、SecurityError：安全错误
                    在getUserMedia() 被调用的 Document 上面，使用设备媒体被禁止。这个机制是否开启或者关闭取决于单个用户的偏好设置。
                7、TypeError：类型错误
                    constraints 对象未设置［空］，或者都被设置为false。
                */
                this.myVideo.srcObject = this.videoStream;
            } catch (error) {
                this.$set(this, 'canUse', false)
                this.$set(this, 'buttonText', 'アップロード')
                console.log(error)
            }
        },
        //base64转file
        base64ImgtoFile(dataurl, filename = 'file') {
            let arr = dataurl.split(',')
            let mime = arr[0].match(/:(.*?);/)[1]
            let suffix = mime.split('/')[1]
            let bstr = atob(arr[1])
            let n = bstr.length
            let u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], `${filename}.${suffix}`, {
                type: mime
            })
        },
        //保存成图片
        upload() {
            const canvas = document.querySelector('#canvas');
            const dataURL = canvas.toDataURL('image/png');
            var that = this;
            //这里的dataURL是一个base64字符串，也可以直接放到img的src里面展示
            let file = that.base64ImgtoFile(dataURL) //这个是base64转file的方法
            // try {
            //     // uploadImage(file,this.orderId,this.orderId+"_car.png")
            //     axios.post('/', {
            //         file: file
            //     },{
            //         params: {
            //             fileName: that.orderId+"_car.png",
            //             s:"App.Upload_Upload.UploadImg",
            //             orderId:that.orderId,
            //         },
            //         headers: {
            //             'Content-Type': 'multipart/form-data',
            //             'Authorization': localStorage.getItem(TOKEN)
            //         }
            //     }).then(response => {
            //         console.log('上传成功', response.data);
            //         that.$alert('上传成功', response.data);
            //     }).catch(error => {
            //         console.error('上传失败', error);
            //         that.$alert('上传失败', error);
            //     });
            // } catch (error) {
            //     console.error('上传失败：', error);
            //     that.$alert('上传失败2', error);
            // }

            var data = new FormData();
            data.append('file', file);
            data.append('orderId', that.orderId);
            data.append('fileName',  new Date().getTime()+ "_car.jpg");
            var config = {
                method: 'post',
                url:  baseURL+'/App/Upload_Upload/uploadCarPhoto',
                headers: {
                    'Authorization': localStorage.getItem(TOKEN)
                },
                data: data
            };
            that.$showLoading()

            axios(config)
                .then(function (response) {
                    console.log(JSON.stringify(response.data));
                    that.$alert('アップロード成功しました');
                    that.$hideLoading()

                })
                .catch(function (error) {
                    console.log(error);
                    that.$alert('アップロード失敗しました');
                    that.$hideLoading()
                });
        },
    },
};
</script>

<style scoped>
.el-icon-plus:before {
    content: "";
}

.btn-bg {
    margin: 2vw 5vw;
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 3.6vw;
    width: 30vw;
}

.btn-bg2 {
    margin: 2vw 4vw;
    padding: 2vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 3.6vw;
    min-width: 30vw;
}
.avatar {
    display: block;
    max-width: 100%;
    height: 62vh;
    margin: 0 auto;
}
.header {
    background: #416ADB;
    height: 8vw;
}
.header-title {
    color: white;
    font-size: 3vw;
    height: 8vw;
    line-height: 8vw;
    margin: 0 auto;
}
.logout-bg {
    margin: 1.5vw 3vw;
    background: #e7373d;
    font-size: 2.4vw;
    padding: 0.8vw 5vw;
    border-radius: 0.8vw;
    color: #FFFFFF;
    border-width: 0.4vw;
    border-color: #891F25;
    border-style: none none solid none;
    position: absolute;
    right: 3vw;
}

</style>